import { Injectable } from '@angular/core';
import { VITAPEN_MEASUREMENT_END, VITAPEN_MEASUREMENT_START, VITAPEN_TEST_END, VITAPEN_TEST_RESULTS, VITAPEN_TEST_START } from './interfaces';
import { extend, range } from 'lodash';
import { timer } from 'rxjs';

export interface TestConfig {
	/**
	 * Anzahl Messungen
	 */
	measurementCount: number;
	/**
	 * Dauer der Messung
	 */
	measurementDuration: number;
	/**
	 * Dauer der Pause zwischen den Messungen
	 */
	pauseDuration: number;
	/**
	 * optionales Logging der Events
	 */
	log?: boolean;
}

@Injectable({
	providedIn: 'root'
})
export class TappingPenMockService {

	constructor(private window: Window) { }

	/**
	 * TappingTest Messprogramm simulieren
	 *
	 * @param config config
	 */
	async runTestProgram(config?: TestConfig): Promise<void> {

		const prng = new SinPRNG();
		const defaults: TestConfig = { measurementCount: 4, measurementDuration: 10, pauseDuration: 6 };
		config = extend({}, defaults, config || {});


		const results = new Array<number>();

		const log = config.log;

		this.emit(log, new Event(VITAPEN_TEST_START));
		for (const measurement of range(1, config.measurementCount + 1)) {
			this.emit(log, new CustomEvent(VITAPEN_MEASUREMENT_START, { detail: { measurement } }));
			await timer(config.measurementDuration * 1000).toPromise();

			const result = Math.floor(prng.random() * 60);
			results.push(result);

			this.emit(log, new CustomEvent(VITAPEN_MEASUREMENT_END, { detail: { measurement, result } }));
			if (measurement < config.measurementCount) {
				await timer(config.pauseDuration * 1000).toPromise();
			}
		}

		this.emit(log, new CustomEvent(VITAPEN_TEST_RESULTS, { detail: { results } }));
		this.emit(log, new Event(VITAPEN_TEST_END));
	}

	private emit(log: boolean, event: Event | CustomEvent): void {
		if (log) {
			console.log(event.type, (<CustomEvent>event).detail);
		}
		this.window.dispatchEvent(event);
	}
}

/**
 * einfacher PseudoRNG auf Basis des Sinus
 */
class SinPRNG {
	constructor(private seed = 1) {}

	random(): number {
		const x = Math.sin(this.seed++) * 10000;
		return x - Math.floor(x);
	}
}
